import { Component, OnInit } from '@angular/core';
import { ManifestoService } from 'src/app/service/manifesto/manifesto.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthGuardService } from 'src/app/service/autenticacao/auth-guard.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AuthService } from 'src/app/service/autenticacao/auth.service';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(public manifestoService: ManifestoService, private route: ActivatedRoute, private authService: AuthService) { }

  ngOnInit() {

    this.manifestoService.carregarDados().subscribe(retorno => {
      retorno.sort((a, b) => a.numeroOrdem - b.numeroOrdem);
      this.manifestoService.listaManifesto = retorno;
    });

  }

}
